(function () {
  'use strict';

  /* Subtle atmospheric charge particles — very low opacity,
     soft gradient threads, gentle pulse. mix-blend-mode:screen
     in CSS means invisible on bright sky, visible on dark sky. */

  const canvas = document.createElement('canvas');
  canvas.id = 'energy-canvas';
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  let W, H;

  const COUNT        = 48;
  const CONNECT_DIST = 190;

  function resize() { W = canvas.width = window.innerWidth; H = canvas.height = window.innerHeight; }

  function mkParticle() {
    const a = Math.random() * Math.PI * 2;
    const s = 0.12 + Math.random() * 0.14;
    return {
      x:     Math.random() * W,
      y:     Math.random() * H,
      vx:    Math.cos(a) * s,
      vy:    Math.sin(a) * s,
      r:     0.5 + Math.random() * 0.9,
      alpha: 0.07 + Math.random() * 0.11,
      pulse: 0,
    };
  }

  function init() {
    resize();
    const particles_ref = [];
    for (let i = 0; i < COUNT; i++) particles_ref.push(mkParticle());
    return particles_ref;
  }

  const P = init();

  function tick() {
    ctx.clearRect(0, 0, W, H);

    for (let i = 0; i < P.length; i++) {
      const p = P[i];

      // Organic drift — slight random wander + dampen
      p.vx = (p.vx + (Math.random() - 0.5) * 0.008) * 0.997;
      p.vy = (p.vy + (Math.random() - 0.5) * 0.008) * 0.997;
      p.x += p.vx;
      p.y += p.vy;

      if (p.x < -12) p.x = W + 12;
      if (p.x > W+12) p.x = -12;
      if (p.y < -12) p.y = H + 12;
      if (p.y > H+12) p.y = -12;

      // Random quiet pulse
      if (p.pulse <= 0 && Math.random() < 0.0008) p.pulse = 50 + (Math.random() * 60 | 0);
      if (p.pulse > 0) p.pulse--;

      // Connections — gradient threads
      for (let j = i + 1; j < P.length; j++) {
        const q  = P[j];
        const dx = p.x - q.x, dy = p.y - q.y;
        const d  = Math.sqrt(dx * dx + dy * dy);
        if (d >= CONNECT_DIST) continue;

        const fade    = 1 - d / CONNECT_DIST;
        const pulsing = p.pulse > 0 || q.pulse > 0;
        const maxA    = pulsing ? 0.10 : 0.032;

        // Gradient thread: brighter at midpoint
        const mid = { x: (p.x + q.x) * 0.5, y: (p.y + q.y) * 0.5 };
        const g   = ctx.createLinearGradient(p.x, p.y, q.x, q.y);
        g.addColorStop(0,   `rgba(80,150,255,${fade * maxA * 0.5})`);
        g.addColorStop(0.5, `rgba(130,190,255,${fade * maxA})`);
        g.addColorStop(1,   `rgba(80,150,255,${fade * maxA * 0.5})`);

        ctx.beginPath();
        ctx.moveTo(p.x, p.y);
        // Slight curve through midpoint for an organic feel
        ctx.quadraticCurveTo(
          mid.x + (Math.random() - 0.5) * 6,
          mid.y + (Math.random() - 0.5) * 6,
          q.x, q.y
        );
        ctx.strokeStyle = g;
        ctx.lineWidth   = pulsing ? 0.6 : 0.4;
        ctx.stroke();
      }

      // Particle
      const a = p.pulse > 0 ? Math.min(0.50, p.alpha * 2.8) : p.alpha;

      if (p.pulse > 0) {
        const glow = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 8);
        glow.addColorStop(0, `rgba(100,170,255,${a * 0.55})`);
        glow.addColorStop(1, 'rgba(100,170,255,0)');
        ctx.fillStyle = glow;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * 8, 0, Math.PI * 2);
        ctx.fill();
      }

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(140,200,255,${a})`;
      ctx.fill();
    }

    requestAnimationFrame(tick);
  }

  window.addEventListener('resize', resize, { passive: true });
  requestAnimationFrame(tick);
})();
